import React from 'react';
import useModal, { IModalPayload } from '@hooks/use-modal';
import { Modal } from 'antd';

import Widget from './Widget';
import { CircleCheck } from 'lucide-react';

const PenaltyApplicationModal = () => {
  const [modal, setModal] =
    useModal<IModalPayload<{ ids: string[]; type: string; time: number }>>(
      'update-penalty',
    );

  const { ids = [] } = modal?.payload || {};
  const onClose = () => {
    setModal({ isOpen: false, payload: null });
  };

  return (
    <Modal
      destroyOnClose
      centered
      width={640}
      onCancel={onClose}
      okButtonProps={{ hidden: true }}
      cancelButtonProps={{ hidden: true }}
      footer={null}
      title={
        <>
          <CircleCheck size={14} className={'mr-2'} />
          Apply penalty
        </>
      }
      visible={(modal?.isOpen && modal?.payload?.type === 'apply') || false}
    >
      <Widget
        ids={ids}
        onClose={onClose}
        processingTime={modal?.payload?.time as number}
      />
    </Modal>
  );
};

export default PenaltyApplicationModal;
